import Flatpickr from 'react-flatpickr'
import {French} from 'flatpickr/dist/l10n/fr.js'
import React, {useRef} from 'react'
import InputGroup from 'react-bootstrap/InputGroup'
import {Link} from 'react-router-dom'
import moment from 'moment'

const DateInput = (props) => {
  const {
    customHeight,
    enableTime = false,
    height = 0,
    blockOpen = false,
    appendTo,
  } = props

  const flatpickrRef = useRef<Flatpickr | null>(null)

  const paramsOptions = {
    locale: French,

    altInput: true,

    altFormat: enableTime
      ? 'd F Y H:i'
      : 'd F Y',

    dateFormat: enableTime
      ? 'Y-m-d H:i'
      : 'Y-m-d',

    enableTime,

    time_24hr: enableTime,

    static: height && (
      props.isStatic !== undefined
        ? props.isStatic
        : true
    ),
    clickOpens: !blockOpen,
    ...(appendTo ? {appendTo} : {}),
  }

  const handleChange = ([date]) => {
    if (!date) {
      props.formik.setFieldValue(props.fieldName, '',)
      props.setter('')
      return
    }
    const formattedValue = enableTime
      ? moment(date).format('YYYY-MM-DD HH:mm')
      : moment(date).format('YYYY-MM-DD')

    props.formik.setFieldValue(props.fieldName, formattedValue)
    props.setter(formattedValue)
  }

  return (
    <>
      <InputGroup size='sm' className='mb-3'>
        <Flatpickr
          ref={flatpickrRef}
          name={props.fieldName}
          value={props.value || null}
          className={props.inputClassName}
          options={paramsOptions}
          placeholder={props.placeholder}
          onChange={handleChange}
        />

        <InputGroup.Text
          id={`basic-addon2-${props.fieldName}`}
          className={customHeight && height !== 0 ? `h-${height}px` : 'h-45px'}
        >
          <button
            type='button'
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={() => {
              if (blockOpen) {
                return
              }

              const instance = flatpickrRef.current?.flatpickr

              if (instance && !instance.isOpen) {
                instance.open()
              }
            }}
          >
            <i className='fa fa-calendar fs-1'></i>
          </button>
        </InputGroup.Text>
      </InputGroup>

      {props.formik.touched[props.fieldName] && props.formik.errors[props.fieldName] && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>{props.formik.errors[props.fieldName]}</div>
        </div>
      )}
    </>
  )
}

export {DateInput}